import React from 'react'
import { Dialog, Typography, IconButton, Box } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const ProviderNotCredentialedModal = ({ open, onClose }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            disableEscapeKeyDown
        >
            <Box p={4} textAlign="center">

                <Box display="flex" justifyContent="flex-end">
                    <IconButton size="small" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Title */}
                <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, mb: 2, color: 'text.primary' }}
                >
                    Provider Not Licensed in Selected State
                </Typography>

                {/* Body */}
                <Typography sx={{ mb: 2, color: 'text.primary' }}>
                    The provider you selected is not credentialed to provide care in the
                    state where you’ll be located for your appointment.
                </Typography>

                <Typography sx={{ color: 'text.primary' }}>
                    Please call us at{' '}
                    <span style={{ color: '#3f51b5', fontWeight: 600 }}>
                        (562) 268-0955
                    </span>{' '}
                    and we’ll help you get scheduled.
                </Typography>

            </Box>
        </Dialog>
    )
}

export default ProviderNotCredentialedModal